module.exports = __webpack_public_path__ + "parth2.0cc4a1b2348891822331.png";


//////////////////
// WEBPACK FOOTER
// E:/Java/ResumeAngular/resume/src/assets/images/parth2.png
// module id = ../../../../../src/assets/images/parth2.png
// module chunks = main